import { LegalPage } from '@/pages/LegalPage';
import { BUSINESS, LEGAL } from '@/data/business';

export default function MentionsLegales() {
    return (
        <LegalPage
            title={<>Mentions<br />légales</>}
            kicker="Informations légales"
            updatedAt={LEGAL.lastUpdated}
            testId="legal-mentions-page"
        >
            <p>
                Conformément aux dispositions des articles 6-III et 19 de la Loi n° 2004-575 du 21 juin
                2004 pour la Confiance dans l'économie numérique (LCEN), il est porté à la connaissance
                des utilisateurs du site <a href="https://www.manuvet.fr">www.manuvet.fr</a> les présentes
                mentions légales.
            </p>

            <h2>1 — Éditeur du site</h2>
            <div className="info-block">
                <dl>
                    <dt>Raison sociale</dt>
                    <dd>{LEGAL.companyName}</dd>
                    <dt>Forme juridique</dt>
                    <dd>{LEGAL.legalForm}</dd>
                    <dt>Capital social</dt>
                    <dd>{LEGAL.capital}</dd>
                    <dt>Siège social</dt>
                    <dd>{BUSINESS.address}, {BUSINESS.postalCode} {BUSINESS.city} — France</dd>
                    <dt>SIREN</dt>
                    <dd>{LEGAL.siren}</dd>
                    <dt>SIRET (siège)</dt>
                    <dd>{LEGAL.siret}</dd>
                    <dt>RCS</dt>
                    <dd>{LEGAL.rcs} — inscrit le {LEGAL.rcsDate}</dd>
                    <dt>N° TVA intracommunautaire</dt>
                    <dd>{LEGAL.vat}</dd>
                    <dt>Téléphone</dt>
                    <dd><a href={`tel:${BUSINESS.phoneTel}`}>{BUSINESS.phone}</a></dd>
                    <dt>Email</dt>
                    <dd><a href={`mailto:${BUSINESS.email}`}>{BUSINESS.email}</a></dd>
                </dl>
            </div>

            <h2>2 — Directeur de la publication</h2>
            <p>
                Le directeur de la publication du site est <strong>{LEGAL.publicationDirector}</strong>, en sa
                qualité de gérant de la société {LEGAL.companyName}.
            </p>

            <h2>3 — Hébergement du site</h2>
            <div className="info-block">
                <dl>
                    <dt>Hébergeur</dt>
                    <dd>{LEGAL.hostName}</dd>
                    <dt>Adresse</dt>
                    <dd>{LEGAL.hostAddress}</dd>
                    <dt>Site web</dt>
                    <dd><a href={LEGAL.hostSite} target="_blank" rel="noopener noreferrer">{LEGAL.hostSite}</a></dd>
                </dl>
            </div>

            <h2>4 — Propriété intellectuelle</h2>
            <p>
                L'ensemble du contenu du site (structure, textes, logos, photographies, illustrations,
                vidéos, éléments graphiques, marques et bases de données) est la propriété exclusive de
                {' '}{LEGAL.companyName} ou de ses partenaires. Toute reproduction, représentation,
                modification, publication, adaptation totale ou partielle des éléments du site, quel que
                soit le moyen ou le procédé utilisé, est interdite sans autorisation écrite préalable de
                {' '}{LEGAL.companyName}, sous peine des sanctions prévues par les articles L.335-2 et
                suivants du Code de la propriété intellectuelle.
            </p>
            <p>
                Les marques citées sur le site (Blaklader, Utility Diadora, Lafont, Safety Jogger, Cepovett,
                Delta Plus, Jallatte, U-Power, Parade, LMA, Singer Safety, Northways, Payper, etc.) sont la
                propriété exclusive de leurs détenteurs respectifs.
            </p>

            <h2>5 — Liens hypertextes</h2>
            <p>
                Le site peut contenir des liens vers des sites tiers (Google Maps, Instagram, Facebook,
                TikTok, sites de marques partenaires). {LEGAL.companyName} n'exerce aucun contrôle sur ces
                sites externes et ne saurait être tenu responsable de leur contenu ou de leur politique de
                confidentialité.
            </p>

            <h2>6 — Responsabilité</h2>
            <p>
                {LEGAL.companyName} met tout en œuvre pour offrir aux utilisateurs des informations et
                outils disponibles et vérifiés. La société ne saurait toutefois être tenue responsable
                des erreurs, d'une absence de disponibilité des fonctionnalités et/ou de la présence de
                virus sur son site. Les informations présentes sur le site sont à caractère indicatif et
                ne constituent pas une offre commerciale ferme.
            </p>

            <h2>7 — Droit applicable</h2>
            <p>
                Le présent site et les présentes mentions légales sont soumis au droit français. En cas de
                litige et à défaut de résolution amiable, compétence exclusive est attribuée aux tribunaux
                français.
            </p>

            <h2>8 — Contact</h2>
            <p>
                Pour toute question relative aux présentes mentions légales, vous pouvez contacter
                {' '}{LEGAL.companyName} par email à <a href={`mailto:${BUSINESS.email}`}>{BUSINESS.email}</a>
                {' '}ou par téléphone au <a href={`tel:${BUSINESS.phoneTel}`}>{BUSINESS.phone}</a>.
            </p>
        </LegalPage>
    );
}
